import React from "react";
import { motion } from "framer-motion";
import MDBox from "components/MDBox";
import { useOnboarding } from "context/OnboardingContext";
import { useMaterialUIController } from "context";
import { getOnboardingThemeTokens, withAlpha } from "./themeTokens";

const OnboardingLayout = ({ children, maxWidth = "600px" }) => {
  const { theme } = useOnboarding();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const t = getOnboardingThemeTokens({ darkMode, templateTheme: theme });

  return (
    <MDBox
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      position="relative"
      overflow="hidden"
        sx={{
          background: `linear-gradient(135deg, ${t.background} 0%, ${t.gradientEnd} 100%)`,
          perspective: "1000px",
          py: 4,
        }}
    >
      {/* Decorative Background Elements */}
      <MDBox
        component={motion.div}
        animate={{
          scale: [1, 1.1, 1],
          rotate: [0, 90, 0],
          x: [0, 30, 0],
          y: [0, -20, 0],
        }}
        transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
        position="absolute"
        top="-5%"
        left="-5%"
        width="30vw"
        height="30vw"
        borderRadius="50%"
        sx={{
          background: `radial-gradient(circle, ${withAlpha(t.primary, 0.12)} 0%, transparent 70%)`,
          filter: "blur(60px)",
          zIndex: 0,
        }}
      />
      <MDBox
        component={motion.div}
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, -45, 0],
          x: [0, -30, 0],
          y: [0, 20, 0],
        }}
        transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
        position="absolute"
        bottom="-10%"
        right="-5%"
        width="40vw"
        height="40vw"
        borderRadius="50%"
        sx={{
          background: `radial-gradient(circle, ${withAlpha(t.primary, 0.09)} 0%, transparent 70%)`,
          filter: "blur(80px)",
          zIndex: 0,
        }}
      />

      <MDBox
        component={motion.div}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        maxWidth={maxWidth}
        width="95%"
        position="relative"
        zIndex={1}
        p={4}
        sx={{
          background: t.panelBg,
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderRadius: "24px",
          border: `1px solid ${t.panelBorder}`,
          boxShadow: t.panelShadow,
        }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
};

export default OnboardingLayout;
